module.exports = __webpack_public_path__ + "img/choose-2.3ab3f9f1.png";